function NotFound() {
    return (
        <div>
            <h2>Oops! You seem to be lost.</h2>
            <p>Tap one of the categories to find your match!</p>
        </div>
    )
}
export default NotFound;